import {Component, EventEmitter, OnInit} from '@angular/core';
import {M4DialogDataEmitter, M4DialogDataInput} from 'ng-metro4';
import {AuthService} from '../../services/auth.service';
import {GenericsService} from '../../services/generics.service';
import {HabilitationToModalDTO} from '../../models/admin/habilitation';
import {AddOrRemoveDepotToUserRequestDTO, AddOrRemoveTierToUserRequestDTO} from '../../models/affectation-retrait';
import {confirmation} from '../../mocks/confirm-response-for-request';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {log} from 'util';
import {TokenStorageService} from "../../services/token-storage.service";

@Component({
  selector: 'app-affectation-retrait',
  templateUrl: './affectation-retrait.component.html',
  styleUrls: ['./affectation-retrait.component.css']
})
export class AffectationRetraitComponent implements OnInit, M4DialogDataInput<any>, M4DialogDataEmitter<any> {
  dialogDataEmitter: EventEmitter<any> = new EventEmitter();
  dialogDataInput: any;
  listeAffecte: any[] = [];
  listeDisponible: any[] = [];
  selectLine: any;
  habilitation: HabilitationToModalDTO;
  objectData: any;
  allData: any;
  rowAttrib: string;
  colAttrib: string;

  public itemsPerPageAffect = 10;
  public currentPageAffect = 0;
  public totalItemsAffect: number;

  public itemsPerPageDispo = 10;
  public currentPageDispo = 0;
  public totalItemsDispo: number;

  public itemsPerPageJ = 10;
  public currentPageJ = 0;
  public totalEltJ: number;
  public removeLine = [];
  public addLine = [];
  key: string;
  componentType: string;
   listCodeJournaux: any;
   listCodeJournauxJONUMCaisse: any;
  submitted: boolean;
   journal: any;
   journalJONUMCaisse: any;
  currentUserObjData: any;
  disponible: string;
  affecte: string;

  constructor(
    public genericsService: GenericsService,
    public tokenStorageService: TokenStorageService,
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.habilitation = this.dialogDataInput?.habilitation;
    console.log(this.habilitation);
    this.allData = this.dialogDataInput;
    this.objectData = this.dialogDataInput?.data;
    this.rowAttrib = this.allData.rowAttrib;
    this.colAttrib = this.allData.libelle;
    this.key = this.allData.key;
    this.componentType = this.allData.componentType;
    this.getDetailsUser();
    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
      this.onReinitData('');
      this.onReinitDataJONUMCaisse('');
    }
    this.disponible = 'AFFECTATION_RETRAIT.' + this.componentType + '_DISPONIBLE';
    this.affecte = 'AFFECTATION_RETRAIT.' + this.componentType + '_AFFECTE';
  }
  getCodeJournal(journal: any): void {
    this.journal = journal;
  }
  onReinitData(keyword): void {
    this.genericsService.getResource(`${this.allData.urlListeCodeJournaux}&token=${keyword}&size=${this.itemsPerPageJ}&page=${this.currentPageJ}`).then((result: any) => {

      if (result.success) {
        this.listCodeJournaux = result.data.content;
        this.totalEltJ = result.data.totalElements;
      }
    }).catch((error) => {
      console.error('Error:', error);
    });
  }
  onFocused(e): void {

    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
      if (e?.target?.value.length <= 0) {
        this.onReinitData('');
      }
      else { this.onReinitData(e?.target?.value); }
    }
  }
  onChangeSearch(search: any): void {
    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
      this.onReinitData(search.term);
    }
  }
  onFocusedJONUMCaisse(e): void {

    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
      if (e?.target?.value.length <= 0) {
        this.onReinitDataJONUMCaisse('');
      }
      else { this.onReinitDataJONUMCaisse(e?.target?.value); }
    }
  }
  onChangeSearchJONUMCaisse(search: any): void {
    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
      this.onReinitDataJONUMCaisse(search.term);
    }
  }
  onReinitDataJONUMCaisse(keyword): void {
    this.genericsService.getResource(
      `/liste/journaux?type=2&token=${keyword}&size=${this.itemsPerPageJ}&page=${this.currentPageJ}`)
      .then((result: any) => {
      console.log(result);
      if (result.success) {
        this.listCodeJournauxJONUMCaisse = result.data.content;
      }
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  clickEventAffecte(event): void{
    this.onListeAffecte(event.target.value);
  }

  clickEventDispo(event): void{
    this.onListetDispo(event.target.value);
  }

  /**
   * Construction de la liste a retirer
   *
   */
  isLineSelectedDispo(elt: any): boolean {
    return this.addLine.some(obj => obj[this.key] === elt[this.key]);
  }
  onSelectLineDispo(elt: any, habilitation: string): void {
    if (this.authService.isVisible(habilitation)) {
      this.removeLine = [];
      this.selectLine = elt;
      const item = this.addLine.indexOf(elt);
      if (item !== -1) {
        this.addLine.splice(item, 1);
      } else {
        this.addLine.push(elt);
      }
    }
  }
  /**
   * Construction de la liste a affecter
   *
   */
  isLineSelectedAffect(elt: any): boolean {
    return this.removeLine.some(obj => obj[this.key] === elt[this.key]);
  }
  onSelectLineAffect(elt: any, habilitation: string): any {
    if (this.authService.isVisible(habilitation)) {
      this.addLine =[];
      this.selectLine = elt;
      const item = this.removeLine.indexOf(elt);
      if (item !== -1) {
        this.removeLine.splice(item, 1);
      } else {
        this.removeLine.push(elt);
      }
    }
  }
  onListeAffecte(token): void {
    this.genericsService.getResource(`${this.allData?.urlListeAffecte}token=${token}&size=${this.itemsPerPageAffect}&page=${this.currentPageAffect}`)
      .then((response: any) => {
      if (response.success) {
        if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
          console.log(response);
          console.log(this.currentUserObjData);
          console.log(this.objectData);
          if (this.objectData?.typeUser === 'TIERS') {
            console.log(this.currentUserObjData);
            this.listeAffecte = [];
            response.data.content.forEach((content: any) => {
              if (content.ctNum === this.currentUserObjData?.ctNum) {
                console.log(content);
                this.listeAffecte.push(this.currentUserObjData);
              }
            });
          }else if (this.objectData?.typeUser === 'GESTIONNAIRE') {
            this.listeAffecte = response.data.content;
            this.totalItemsAffect = response.data.totalElements;
          }
        }else {
          this.listeAffecte = response.data.content;
          this.totalItemsAffect = response.data.totalElements;
        }
      } else {

      }
    }).catch((error: any) => {
      console.error(error);

    });
  }

  getDetailsUser(): void {
    console.log(this.objectData);
    if (this.objectData?.typeUser === 'TIERS') {
      this.genericsService.getResource(`/utilisateur-mobile/${this.objectData?.id}`)
        .then((res: any) => {
          console.log(res);
          if (res.success) {
            this.currentUserObjData = res.data;
            this.onListeAffecte('');
            this.onListetDispo('');
          }
        }).catch((err: any) => {
        console.log(err);
        if (err.status === 400) {
          Swal.fire(confirmation(err.error.message,
            'error', 'error', true, 10000));
        }else {
          Swal.fire(confirmation(err.message,
            'error', 'error', true, 10000));
        }
      });
    }else if (this.objectData?.typeUser === 'GESTIONNAIRE') {
      this.onListeAffecte('');
      this.onListetDispo('');
    }
  }

  onListetDispo(token): void {
    this.genericsService.getResource(`${this.allData?.urlListeDispo}token=${token}&size=${this.itemsPerPageDispo}&page=${this.currentPageDispo}`).then((response: any) => {
      if (response.success) {
        if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR') {
          if (this.objectData?.typeUser === 'TIERS') {
            console.log(response);
            console.log(this.currentUserObjData);
            console.log(this.objectData);
            this.listeDisponible = [];
            response.data.content.forEach((content: any) => {
              if (content.ctNum === this.currentUserObjData?.ctNum) {
                this.listeDisponible.push(this.currentUserObjData);
              }
            });
          }else if (this.objectData?.typeUser === 'GESTIONNAIRE') {
            this.listeDisponible = response.data.content;
            this.totalItemsDispo = response.data.totalElements;
          }
        }else {
          this.listeDisponible = response.data.content;
          this.totalItemsDispo = response.data.totalElements;
        }
      }
    }).catch((error: any) => {
      console.error(error);

    });
  }
  affecter(): void{
    console.log(this.journal);
    let dto;
    const tabIds = [];
    if (this.addLine.length > 0) {
      this.addLine.forEach(line => tabIds.push(line[this.key]));
    }
    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR'){
      this.submitted = true;
      if (!this.journal){
        const msgV = this.tokenStorageService.getLangue() === 'FR' ? 'Veillez choisir le code journal vente' : 'Please choose journal sale';
        Swal.fire(confirmation(msgV,
          'center', 'error', true, 10000));
        return;
      }
      if (!this.journalJONUMCaisse){
        const msgC = this.tokenStorageService.getLangue() === 'FR'
          ? 'Veillez choisir le code journal caisse' : 'Please choose journal cash';
        Swal.fire(confirmation(msgC,
          'center', 'error', true, 10000));
        return;
      }
      dto = new AddOrRemoveTierToUserRequestDTO(
        'AFFECTATION',
        parseInt(this.objectData?.id, 10),
        tabIds,
        this.journal,
        this.journalJONUMCaisse
      );
    }
    if (this.componentType === 'DEPOT'){
      dto = new AddOrRemoveDepotToUserRequestDTO(
        'AFFECTATION',
        parseInt(this.objectData?.id, 10),
        tabIds
      );
    }
    this.genericsService.postResource(this.allData?.urlAffectation, dto).then((response: any) => {

      this.onListeAffecte('');
      this.onListetDispo('');
    }).catch((err: any) => {
      if (err.error){
        Swal.fire(confirmation(err.error.message,
          'center', 'error', true, 10000));
      }else {
        Swal.fire(confirmation(err.message,
          'center', 'error', true, 10000));
      }
    });
    this.addLine = [];
  }
  retrait(): void{
    let dto;
    const tabIds = [];
    if (this.removeLine.length > 0) {
      this.removeLine.forEach(line => tabIds.push(line[this.key]));
    }
    if (this.componentType === 'CLIENT' || this.componentType === 'FOURNISSEUR'){
      dto = new AddOrRemoveTierToUserRequestDTO(
        'RETRAIT',
        parseInt(this.objectData?.id, 10),
        tabIds,
        null
      );
    }
    if (this.componentType === 'DEPOT'){
      dto = new AddOrRemoveDepotToUserRequestDTO(
        'RETRAIT',
        parseInt(this.objectData?.id, 10),
        tabIds
      );
    }
    this.genericsService.postResource(this.allData?.urlRetrait, dto).then((response: any) => {

      this.onListeAffecte('');
      this.onListetDispo('');
    }).catch((err: any) => {
      if (err.error){
        Swal.fire(confirmation(err.error.message,
          'center', 'error', true, 10000));
      }else {
        Swal.fire(confirmation(err.message,
          'center', 'error', true, 10000));
      }
    });
    this.removeLine = [];
  }

  onChangePageDispo(event): void {
    this.currentPageDispo = event - 1;
    this.onListetDispo('');
    this.addLine = [];
  }
  onChangePageAffect(event): void {
    this.currentPageAffect = event - 1;
    this.onListeAffecte('');
    this.removeLine = [];
  }
  onClose(): void {
    this.dialogDataEmitter.emit();
    this.genericsService.closeModalAndSendData();
  }
}
